<div class="role-create">
  <div class="role-create__content">
    <div class="role-create__header">
      <div class="role-create__heading">
        <h1 class="page-title">Create Role</h1>
        <p class="page-subtitle">Define a new role with specific permissions.</p>
      </div>
      <div class="role-create__actions">
        <button class="role-create__secondary-btn" type="button" (click)="goBack()">Back</button>
        <button class="role-create__primary-btn" type="button" [disabled]="isSaving || !name.value.trim()" (click)="createRole()">
          {{ isSaving ? "Creating..." : "Create role" }}
        </button>
      </div>
    </div>

    @if (errorMessage) {
    <div class="role-create__error">{{ errorMessage }}</div>
    }

    <section class="role-create__card role-create__card--details">
      <h2 class="role-create__section-title">Role Details</h2>
      <div class="role-create__details-grid">
        <div class="role-create__form-group">
          <label for="name" class="role-create__form-label">Role Name</label>
          <input id="name" class="role-create__form-input" type="text" [formControl]="name" placeholder="Enter role name" />
          @if (name.invalid && name.touched) {
          <div class="role-create__form-error">Role name is required.</div>
          }
        </div>

        <div class="role-create__form-group">
          <label for="description" class="role-create__form-label">Description</label>
          <input
            id="description"
            class="role-create__form-input"
            type="text"
            [formControl]="description"
            placeholder="Enter role description" />
        </div>
      </div>
    </section>

    <div class="role-create__layout">
      <section class="role-create__card role-create__card--permissions">
        <div class="role-create__section-header">
          <div>
            <h2 class="role-create__section-title">Permissions</h2>
            <p class="role-create__section-hint">Select the permissions that apply to this role.</p>
          </div>
          <div class="role-create__header-actions">
            <button class="role-create__module-btn" type="button" (click)="selectAllPermissions()">Select all</button>
            <button class="role-create__module-btn" type="button" (click)="deselectAllPermissions()">Deselect all</button>
            <div class="role-create__search">
              <input
                class="role-create__search-input"
                type="text"
                [formControl]="permissionSearch"
                placeholder="Search by module, action, or description" />
            </div>
          </div>
        </div>

        @if (permissionState.loading()) {
        <div class="role-create__loading">Loading permissions...</div>
        } @else { @if (permissionGroups.length === 0) {
        <div class="role-create__empty">No permissions match your search.</div>
        } @else {
        <div class="role-create__modules">
          @for (group of permissionGroups; track group.module) {
          <div class="role-create__module">
            <div class="role-create__module-header">
              <div class="role-create__module-meta">
                <h3 class="role-create__module-title">{{ group.module }}</h3>
                <span class="role-create__module-count">{{ group.permissions.length }} permissions</span>
              </div>
              <button class="role-create__module-btn" type="button" (click)="toggleModulePermissions(group.module)">
                {{ areAllModulePermissionsSelected(group.module) ? "Remove all" : "Select all" }}
              </button>
            </div>
            <div class="role-create__permissions">
              @for (permission of group.permissions; track permission.id) {
              <label class="role-create__permission">
                <input type="checkbox" [checked]="isPermissionSelected(permission.id)" (change)="togglePermission(permission.id)" />
                <span class="role-create__permission-text">
                  <span class="role-create__permission-action">{{ permission.action }}</span>
                  <span class="role-create__permission-desc"
                    >{{ permission.description || (permission.module + ":" + permission.action) }}</span
                  >
                </span>
              </label>
              }
            </div>
          </div>
          }
        </div>
        } }
      </section>

      <section class="role-create__card role-create__card--summary">
        <h2 class="role-create__section-title">Role details</h2>
        <div class="role-create__summary">
          <div class="role-create__summary-row">
            <span class="role-create__summary-label">Name</span>
            <span class="role-create__summary-value">{{ name.value || "-" }}</span>
          </div>
          <div class="role-create__summary-row">
            <span class="role-create__summary-label">Description</span>
            <span class="role-create__summary-value">{{ description.value || "-" }}</span>
          </div>
          <div class="role-create__summary-row">
            <span class="role-create__summary-label">Selected permissions</span>
            <span class="role-create__summary-value">{{ selectedPermissionIds.size }}</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
